import { render, staticRenderFns } from "./HotArticle.vue?vue&type=template&id=7216e562&scoped=true"
import script from "./HotArticle.vue?vue&type=script&lang=js"
export * from "./HotArticle.vue?vue&type=script&lang=js"
import style0 from "./HotArticle.vue?vue&type=style&index=0&id=7216e562&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216e562",
  null
  
)

export default component.exports